import React from "react";
import { addDays, format } from "date-fns";

interface MonthSpan {
  month: string;
  width: number;
}

interface MonthHeaderProps {
  weekDates: Date[];
  columnWidth: number;
}

const MonthHeader: React.FC<MonthHeaderProps> = ({
  weekDates,
  columnWidth,
}) => {
  const monthCells: MonthSpan[] = [];

  for (let i = 0; i < weekDates.length; i++) {
    const start = weekDates[i];

    for (let j = 0; j < 7; j++) {
      const day = addDays(start, j);
      const month = format(day, "MMM");
      const width = columnWidth / 7;

      if (
        monthCells.length === 0 ||
        monthCells[monthCells.length - 1].month !== month
      ) {
        monthCells.push({ month, width });
      } else {
        monthCells[monthCells.length - 1].width += width;
      }
    }
  }

  return (
    <div className="flex text-xs font-semibold text-center text-gray-700">
      {monthCells.map((cell, idx) => (
        <div
          key={idx}
          className="flex items-center justify-center border border-gray-100 bg-gray-50"
          style={{
            width: `${cell.width}px`,
            minWidth: `${cell.width}px`,
            height: "30px",
          }}
        >
          {cell.month}
        </div>
      ))}
    </div>
  );
};

export default MonthHeader;
